/* Charmies product page. Port of src/routes/product.$slug.tsx (charm + simple modes).
 * Charm: Single/Duo/Trio tier selector + per-item Color+Scent pickers. Every tier
 * bills the charmies-bundle tier variant (one line) with the pieces as line-item
 * properties — handed to CharmiesCart.addBundle. Simple add-ons bill their own variant. */
(function () {
  'use strict';
  var P = window.CHARMIES_PRODUCT;
  var root = document.getElementById('charmies-pdp');
  if (!P || !root) return;
  if (P.mode === 'package') return; // packages use their own configurator (charmies-package.js)

  var isAr = ((window.CHARMIES || {}).locale === 'ar');
  var money = (window.CharmiesCart && window.CharmiesCart.money) || function (n) { return isAr ? Number(n).toFixed(2) + ' QAR' : 'QAR ' + Number(n).toFixed(2); };
  var SCENTS = window.CHARMIES_SCENTS || [];
  var HAS_SCENT = P.hasScent !== false;
  // A charm with no Scent VARIANT still offers a free scent (brand promise: "every charm
  // comes with a free scent") — recorded as a gift line-item property, NOT a priced variant.
  // Uses CHARMIES_SCENTS (bilingual) so AR works with no per-product translation; the billed
  // variant is matched by COLOUR only. So SHOW_SCENT is true for every charm.
  var SINGLE_ONLY = !!P.singleOnly; // charm UI (colour + scent) but NO Duo/Trio tiers (e.g. Makeup)
  var NO_SCENT = !!P.noScent;        // plain product: colour only, no free-scent picker (e.g. Jacket)
  var SCENT_GIFT = (P.mode === 'charm') && !HAS_SCENT && !NO_SCENT;
  var SHOW_SCENT = HAS_SCENT || SCENT_GIFT;
  // Per-product tiers: look up THIS product's own price in the Charmies Tiers table.
  // Single is always offered and bills the product's OWN variant at price P; Duo/Trio
  // come from the table (the % + round8 formula prices) and bill the shared tier variant.
  var TIER_TABLE = {};
  (window.CHARMIES_TIER_VARIANTS || []).forEach(function (r) {
    if (!TIER_TABLE[r.base]) TIER_TABLE[r.base] = {};
    TIER_TABLE[r.base][r.tier] = { variantId: r.variantId, price: r.price };
  });
  var TIER_ROW = TIER_TABLE[String(Math.round(P.basePrice))] || null;
  var TIERS = [{ qty: 1, price: P.basePrice, variantId: null, labelEn: '1 piece', labelAr: 'قطعة واحدة', originalPrice: 0, savingsPct: 0, bestDeal: false }];
  ['duo', 'trio'].forEach(function (key, i) {
    if (!TIER_ROW || !TIER_ROW[key]) return;
    var qty = i + 2, orig = P.basePrice * qty, price = TIER_ROW[key].price;
    TIERS.push({ qty: qty, price: price, variantId: TIER_ROW[key].variantId, labelEn: qty + ' pieces', labelAr: qty === 2 ? 'قطعتين' : 'ثلاث قطع', originalPrice: orig, savingsPct: orig > price ? Math.round((orig - price) / orig * 100) : 0, bestDeal: qty === 3 });
  });
  if (SINGLE_ONLY) { TIERS = [TIERS[0]]; } // single-only products (e.g. Makeup): keep only the 1-piece tier
  var CHECK = '<svg aria-hidden="true" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';

  function L(en, ar) { var b = window.charmiesT; return (b && b[en] != null) ? b[en] : (isAr ? ar : en); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function err(m) { if (window.CharmiesCart && window.CharmiesCart.toastError) window.CharmiesCart.toastError(m); else alert(m); }
  // Colour name comes from the variant data in the ACTIVE locale (English or Arabic).
  // Map it to the canonical EN/AR pair (+ hex) regardless of which locale it arrived in.
  function colorEntry(n) { var s = (n || '').trim().toLowerCase(); return (window.CHARMIES_COLORS || []).find(function (c) { return c.en.toLowerCase() === s || c.ar === n; }); }
  function colorAr(n) { var e = colorEntry(n); return e ? e.ar : n; }
  function colorEnOf(n) { var e = colorEntry(n); return e ? e.en : n; }
  function colorHex(n) { var e = colorEntry(n); return e ? e.hex : null; }
  function typeInfo() { return { en: P.nameEn, ar: P.nameAr || P.nameEn }; }
  function scentById(id) { return SCENTS.find(function (s) { return s.id === id; }); }
  function findVariant(colorEn, scentEn) {
    var c = (colorEn || '').trim().toLowerCase(), s = (scentEn || '').trim().toLowerCase();
    return (P.variants || []).find(function (v) { return (v.color || '').trim().toLowerCase() === c && (v.scent || '').trim().toLowerCase() === s; }) || null;
  }
  function colorByName(n) { return (P.colors || []).find(function (c) { return c.name === n; }); }
  function firstInStockColor() { return (P.colors || []).find(function (c) { return !c.oos; }) || (P.colors || [])[0]; }

  // ── ViewContent pixel (canonical EN name, like Lovable's product.name_en) ──
  if (window.CharmiesPixels) {
    window.CharmiesPixels.viewContent({ contentName: typeInfo().en, items: [{ id: String(P.firstVariantId || P.id), quantity: 1, price: P.basePrice, name: typeInfo().en }], value: P.basePrice });
  }

  // ── live viewer badge ──
  (function () {
    var el = root.querySelector('[data-pdp-viewers]');
    if (!el) return;
    var min = P.viewerMin || 12, max = P.viewerMax || 48;
    var n = Math.floor(min + Math.random() * (max - min + 1));
    el.textContent = n;
    var t = setInterval(function () {
      if (document.hidden) return; // no wakeup work while the tab is backgrounded
      n += Math.random() < 0.5 ? -1 : 1; if (n < min) n = min; if (n > max) n = max; el.textContent = n;
    }, 3500);
    window.addEventListener('pagehide', function () { clearInterval(t); }, { once: true });
  })();

  // ── gallery (swipeable scroll-snap carousel + thumbnails) ──
  var gallery = root.querySelector('[data-pdp-gallery]');
  var mainImg = root.querySelector('[data-pdp-main]');            // single-photo fallback
  var slides = gallery ? [].slice.call(gallery.querySelectorAll('[data-pdp-slide]')) : [];
  var activeGalleryUrl = (P.images || [])[0] || '';
  function baseOf(u) { return (u || '').split('?')[0]; }
  function setActiveThumb(idx) {
    root.querySelectorAll('[data-pdp-thumb]').forEach(function (b, i) {
      var on = i === idx;
      b.classList.toggle('border-primary', on);
      b.classList.toggle('border-transparent', !on);
      b.classList.toggle('opacity-70', !on);
    });
  }
  // Point the gallery at an image: the carousel smooth-scrolls to that slide (single-photo mode swaps src).
  function setGalleryImage(url) {
    if (!url) return;
    activeGalleryUrl = url;
    if (slides.length) {
      var b = baseOf(url);
      for (var i = 0; i < slides.length; i++) {
        if (baseOf(slides[i].getAttribute('src')) === b) { gallery.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' }); setActiveThumb(i); return; }
      }
    } else if (mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = url; }
  }
  function setPrice(major) { var pe = root.querySelector('[data-pdp-price]'); if (pe) pe.textContent = money(major); }

  // Thumbnail tap → scroll the carousel to that photo.
  root.addEventListener('click', function (e) {
    var th = e.target.closest('[data-pdp-thumb]');
    if (!th) return;
    setGalleryImage(th.getAttribute('data-pdp-thumb'));
  });

  // As the shopper swipes, keep the matching thumbnail highlighted.
  if (gallery && slides.length) {
    var gt;
    gallery.addEventListener('scroll', function () {
      clearTimeout(gt);
      gt = setTimeout(function () {
        var w = gallery.clientWidth || 1;
        setActiveThumb(Math.round(gallery.scrollLeft / w));
      }, 60);
    }, { passive: true });
  }

  var controls = root.querySelector('[data-pdp-controls]');

  // ── SIMPLE mode (plain products: add-ons AND multi-variant items like phone cases) ──
  if (P.mode === 'simple') {
    var pickList = (P.variants || []);
    var options = P.simpleOptions || [];                     // product option order; index i maps to variant.options[i]
    var showPickers = pickList.length > 1 && options.length > 0;
    // Render order: the phone size/model first, Colour last — matches how people choose (pick the phone, then the colour).
    var order = options.map(function (o, i) { return i; }).sort(function (a, b) {
      var ac = /^(color|اللون)$/i.test(options[a].name) ? 1 : 0;
      var bc = /^(color|اللون)$/i.test(options[b].name) ? 1 : 0;
      return ac - bc;
    });
    var firstAvail = pickList.filter(function (v) { return v.available !== false; })[0] || pickList[0] || null;
    var selected = (firstAvail && firstAvail.options) ? firstAvail.options.slice() : options.map(function (o) { return (o.values || [])[0]; });
    function matchVariant() {
      return pickList.filter(Boolean).find(function (v) {
        return options.every(function (o, i) { return (v.options || [])[i] === selected[i]; });
      }) || null;
    }
    var sel = matchVariant() || firstAvail || { id: P.simpleVariantId, price: P.basePrice, image: null };
    var qty = 1;
    function selPrice() { return (sel && sel.price != null) ? sel.price : P.basePrice; }
    function lineTotal() { return selPrice() * qty; }
    function selAvailable() { return !sel || sel.available !== false; }
    function valueInStock(i, val) { return pickList.some(function (v) { return (v.options || [])[i] === val && v.available !== false; }); }
    function setCompare() {
      var cmp = root.querySelector('[data-pdp-compare]'), sav = root.querySelector('[data-pdp-save]');
      var c = sel && sel.compareAt, show = c && c > selPrice();
      if (cmp) { cmp.textContent = show ? money(c) : ''; cmp.classList.toggle('hidden', !show); }
      if (sav) { sav.textContent = show ? ('-' + Math.round((c - selPrice()) / c * 100) + '%') : ''; sav.classList.toggle('hidden', !show); }
    }

    function renderSimple() {
      var html = '';
      if (P.isAddon) {
        html += '<div class="mb-2 text-xs italic text-muted-foreground">' + L('Essential add-on — not a Charmie', 'إضافة أساسية — مو تشارمي') + '</div>';
      }
      if (showPickers) {
        order.forEach(function (i) {
          var o = options[i];
          html += '<div class="mb-4"><div class="mb-2 text-sm font-medium text-primary">' + esc(o.name) + '</div><div class="flex flex-wrap gap-2">';
          (o.values || []).forEach(function (val) {
            var on = selected[i] === val, stock = valueInStock(i, val);
            html += '<button type="button" data-opt="' + i + '" data-val="' + esc(val) + '"' + (stock ? '' : ' disabled') +
              ' class="rounded-full border-2 px-4 py-2 text-sm font-medium transition ' +
              (on ? 'border-primary bg-primary/5 text-primary' : 'border-border text-muted-foreground hover:border-primary/40') +
              (stock ? '' : ' cursor-not-allowed opacity-40 line-through') + '">' + esc(val) + '</button>';
          });
          html += '</div></div>';
        });
      }
      html += '<div class="mb-4 flex items-center gap-3"><span class="text-sm font-medium text-primary">' + L('Quantity', 'الكمية') + '</span>' +
        '<div class="inline-flex items-center rounded-full border-2 border-border">' +
          '<button type="button" data-qty-dec' + (qty <= 1 ? ' disabled' : '') + ' aria-label="' + esc(L('Decrease', 'إنقاص')) + '" class="grid h-11 w-11 place-items-center text-xl font-bold leading-none text-primary disabled:opacity-30">−</button>' +
          '<span class="w-10 text-center text-base font-bold">' + qty + '</span>' +
          '<button type="button" data-qty-inc aria-label="' + esc(L('Increase', 'زيادة')) + '" class="grid h-11 w-11 place-items-center text-xl font-bold leading-none text-primary">+</button>' +
        '</div></div>';
      var desc = selected.filter(Boolean).join(' · ') + (qty > 1 ? ' ×' + qty : '');
      html += ctaBar(money(lineTotal()), !selAvailable(), desc);
      controls.innerHTML = html;
      setPrice(selPrice());
      setCompare();
    }

    controls.addEventListener('click', function (e) {
      var b = e.target.closest('[data-opt]');
      if (b && !b.disabled) {
        var i = parseInt(b.getAttribute('data-opt'), 10), val = b.getAttribute('data-val');
        if (selected[i] !== val) {
          selected[i] = val;
          var m = matchVariant();
          if (m) { sel = m; if (sel.image) setGalleryImage(sel.image); }
          renderSimple();
        }
        return;
      }
      if (e.target.closest('[data-qty-dec]')) { if (qty > 1) { qty--; renderSimple(); } return; }
      if (e.target.closest('[data-qty-inc]')) { qty++; renderSimple(); return; }
    });

    renderSimple();
    wireCtas(function () {
      if (!selAvailable()) { err(L('Sorry, this option is sold out', 'عذراً، هذا الخيار غير متوفر حالياً')); return null; }
      var ti = typeInfo();
      var desc = selected.filter(Boolean).join(' · ');
      var nmEn = desc ? (ti.en + ' — ' + desc) : ti.en;
      var nmAr = desc ? (ti.ar + ' — ' + desc) : ti.ar;
      return { simple: true, line: { variantId: sel.id, quantity: qty, titleEn: nmEn, nameEn: nmEn, nameAr: nmAr, image: (P.images || [])[0] || '', totalPrice: lineTotal() } };
    });
    return;
  }

  // ── CHARM mode (tiers + slots) ──
  if (!TIERS.length) { controls.innerHTML = '<p class="text-sm text-muted-foreground">' + L('Bundles are currently unavailable.', 'الباقات غير متوفرة حالياً.') + '</p>'; return; }
  var bestTier = TIERS.find(function (t) { return t.bestDeal; }) || TIERS[TIERS.length - 1] || { qty: 1 };
  var state = { qty: bestTier.qty, active: 0, slots: [] };
  function tierByQty(q) { return TIERS.find(function (t) { return t.qty === q; }) || TIERS[0]; }

  function syncSlots() {
    var def = firstInStockColor();
    var next = [];
    for (var i = 0; i < state.qty; i++) next.push(state.slots[i] || { color: def ? def.name : '', scent: '' });
    state.slots = next;
    if (state.active > state.qty - 1) state.active = state.qty - 1;
  }
  syncSlots();

  function isComplete() { return state.slots.length > 0 && state.slots.every(function (s) { return s.color && (s.scent || !SHOW_SCENT); }); }

  function render() {
    var tier = tierByQty(state.qty);
    var html = '';
    // Special offer divider + tiers (hidden when there's only the 1-piece tier, e.g. single-only)
    if (TIERS.length > 1) {
    html += '<div class="relative my-4 flex items-center"><div class="h-px flex-1 bg-border"></div><span class="mx-3 text-sm font-semibold tracking-wide">' + L('Special Offer', 'عرض خاص') + '</span><div class="h-px flex-1 bg-border"></div></div>';
    html += '<div class="grid grid-cols-3 gap-3">';
    TIERS.forEach(function (t) {
      var sel = t.qty === state.qty;
      html += '<button type="button" data-tier="' + t.qty + '" aria-pressed="' + sel + '" class="relative rounded-2xl border-2 p-3 text-center transition ' + (sel ? 'border-primary bg-primary/5 shadow-md' : 'border-border bg-card/60') + '">' +
        (t.bestDeal ? '<span class="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-primary px-3 py-0.5 text-[10px] font-bold text-primary-foreground">' + L('Best Deal', 'أفضل عرض') + '</span>' : '') +
        '<div class="mx-auto mb-2 grid h-5 w-5 place-items-center rounded-lg border-2 transition ' + (sel ? 'border-primary bg-primary text-primary-foreground' : 'border-muted-foreground/40') + '">' + (sel ? CHECK : '') + '</div>' +
        '<div class="text-sm font-bold">' + esc(isAr ? t.labelAr : t.labelEn) + '</div>' +
        '<div class="mt-1 text-xs text-muted-foreground">×' + t.qty + '</div>' +
        '<div class="mt-2 text-sm font-bold">' + esc(money(t.price)) + '</div>' +
        (t.originalPrice ? '<div class="text-[11px] text-muted-foreground line-through">' + esc(money(t.originalPrice)) + '</div>' : '') +
        (t.savingsPct ? '<div class="mt-1 text-[11px] font-semibold text-rose-deep">' + L('You save', 'وفّر') + ' ' + t.savingsPct + '%</div>' : '') +
        '</button>';
    });
    html += '</div>';
    }

    // Slots
    html += '<div class="mt-4 space-y-3">';
    state.slots.forEach(function (slot, i) {
      var col = colorByName(slot.color);
      var sc = scentById(slot.scent);
      var sub = (col ? (isAr ? colorAr(col.name) : col.name) : '') + (col && sc ? ' · ' : '') + (sc ? (isAr ? sc.ar : sc.en) : '');
      html += '<div data-slot="' + i + '" class="rounded-2xl border-2 bg-card p-3 transition ' + (state.active === i ? 'border-primary' : 'border-border') + '">' +
        '<div class="mb-3 flex items-center justify-between text-xs font-semibold uppercase tracking-wide text-muted-foreground"><span>' + L('Item', 'العنصر') + ' ' + (i + 1) + '</span><span class="normal-case text-muted-foreground">' + esc(sub) + '</span></div>' +
        '<div class="mb-2 text-xs font-medium">' + L('Color', 'اللون') + '</div><div class="mb-4 flex flex-wrap gap-2">';
      (P.colors || []).forEach(function (c) {
        var selc = slot.color === c.name;
        var cName = isAr ? colorAr(c.name) : c.name;
        var chex = colorHex(c.name) || c.hex;
        html += '<button type="button" data-pick-color="' + esc(c.name) + '" aria-label="' + esc(cName) + '" aria-pressed="' + selc + '" title="' + (c.oos ? esc(L('Coming soon', 'قريباً')) : esc(cName)) + '"' + (c.oos ? ' disabled' : '') +
          ' class="relative grid h-11 w-11 place-items-center overflow-hidden rounded-full border-2 bg-muted transition ' + (selc ? 'border-primary scale-110 ring-2 ring-primary/30' : 'border-border') + (c.oos ? ' opacity-40 grayscale cursor-not-allowed' : '') + '" style="' + (c.image ? "background-image:url(" + esc(c.image) + ");background-size:cover;background-position:center" : 'background:' + esc(chex)) + '">' +
          (selc ? '<span class="relative z-10 grid h-5 w-5 place-items-center rounded-full bg-primary text-primary-foreground shadow">' + CHECK + '</span>' : '') +
          '</button>';
      });
      html += '</div>';
      if (SHOW_SCENT) {
        var hasColor = !!slot.color;
        html += '<div class="mb-2 text-xs font-medium">' + L('Choose a scent', 'اختاري العطر') + '</div>';
        html += '<p data-scent-hint class="mb-2 hidden text-xs font-semibold text-rose-deep">' + esc(L('Choose your colour first 🎨', 'اختاري اللون أولاً 🎨')) + '</p>';
        html += '<div class="grid grid-cols-2 gap-2 sm:grid-cols-4">';
        SCENTS.forEach(function (s) {
          var sels = slot.scent === s.id;
          var unavailable = false; // only a real "coming soon" once a colour is chosen (non-gift charms)
          if (hasColor && !SCENT_GIFT) { var variant = findVariant(slot.color, isAr ? s.ar : s.en); unavailable = !variant || !variant.available; }
          var cls = 'flex min-h-11 items-center justify-center gap-1 rounded-xl border-2 px-2 py-3 text-xs font-medium transition ';
          if (sels) { cls += 'border-primary bg-primary/10 text-primary'; }
          else if (unavailable) { cls += 'border-border opacity-40 cursor-not-allowed line-through'; }
          else { cls += 'border-border hover:border-primary/40'; } // no colour yet -> looks normal, guides on tap
          var bestSeller = s.id === 'miss-coco' && !unavailable;
          var bestBadge = bestSeller ? '<span aria-hidden="true" style="position:absolute;top:-7px;left:50%;transform:translateX(-50%);white-space:nowrap;background:#f5b833;color:#4a2c17;font-size:8.5px;line-height:1.2;font-weight:800;letter-spacing:.02em;padding:2px 7px;border-radius:999px;box-shadow:0 1px 3px rgba(20,20,45,.22);z-index:2">★ ' + (isAr ? 'الأكثر مبيعاً' : 'Best Seller') + '</span>' : '';
          html += '<button type="button" data-pick-scent="' + s.id + '"' + (hasColor ? '' : ' data-needs-color="1"') + ' aria-pressed="' + sels + '"' + (unavailable ? ' disabled title="' + esc(L('Coming soon', 'قريباً')) + '"' : '') +
            (bestSeller ? ' style="position:relative"' : '') +
            ' class="' + cls + '">' + bestBadge + (sels ? CHECK : '') + '<span>' + esc(isAr ? s.ar : s.en) + '</span></button>';
        });
        html += '</div>';
      }
      html += '</div>';
    });
    html += '</div>';

    // Summary
    if (isComplete()) {
      html += '<div class="mt-4 rounded-2xl bg-blush/50 p-4 ring-1 ring-rose-soft/40"><div class="mb-2 text-sm font-semibold text-primary">' + L('Your bundle', 'باقتك') + '</div><ul class="space-y-1 text-sm">';
      state.slots.forEach(function (slot, i) {
        var col = colorByName(slot.color), sc = SHOW_SCENT ? scentById(slot.scent) : null;
        var line = (i + 1) + '. ' + esc(L(typeInfo().en, typeInfo().ar)) + ' · ' + esc(isAr ? colorAr(col.name) : col.name) + (sc ? ' · ' + esc(isAr ? sc.ar : sc.en) : '');
        html += '<li class="flex justify-between gap-2"><span class="whitespace-normal break-words">' + line + '</span></li>';
      });
      html += '</ul><div class="mt-3 flex items-baseline justify-between border-t border-rose-soft/40 pt-2 font-semibold"><span>' + L('Total', 'المجموع') + '</span><span class="text-right"><span class="text-base">' + esc(money(tier.price)) + '</span>' + (tier.originalPrice ? '<span class="ms-2 text-xs font-normal text-muted-foreground line-through">' + esc(money(tier.originalPrice)) + '</span>' : '') + '</span></div></div>';
    }

    html += ctaBar(money(tier.price), !isComplete());
    controls.innerHTML = html;
    setPrice(tier.price);
    updateGalleryToActive();
  }

  function updateGalleryToActive() {
    var slot = state.slots[state.active];
    if (!slot) return;
    var col = colorByName(slot.color);
    if (col && col.image) {
      setGalleryImage(col.image);
      root.querySelectorAll('[data-pdp-thumb]').forEach(function (b) {
        var on = b.getAttribute('data-pdp-thumb') === col.image;
        b.classList.toggle('border-primary', on);
        b.classList.toggle('border-transparent', !on);
        b.classList.toggle('opacity-70', !on);
      });
    }
  }

  function ctaBar(priceStr, disabled, itemDesc) {
    var addLabel = L('Add to Cart', 'أضف إلى السلة');
    var buyLabel = L('Buy it now', 'اشترِ الآن');
    var waLabel = L('Order via WhatsApp', 'اطلبي عبر واتساب');
    var waIcon = '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12.04 2a9.9 9.9 0 0 0-8.44 15.1L2 22l5.05-1.32A9.9 9.9 0 1 0 12.04 2zm0 1.8a8.1 8.1 0 0 1 0 16.2 8 8 0 0 1-4.1-1.12l-.29-.17-3 .78.8-2.92-.19-.3A8.1 8.1 0 0 1 12.04 3.8zm4.5 10.3c-.24-.12-1.44-.71-1.66-.79-.22-.08-.38-.12-.55.12-.16.24-.63.79-.77.95-.14.16-.28.18-.52.06-.24-.12-1.02-.38-1.95-1.2-.72-.64-1.2-1.44-1.35-1.68-.14-.24-.01-.37.11-.49.11-.11.24-.28.36-.42.12-.14.16-.24.24-.4.08-.16.04-.3-.02-.42-.06-.12-.55-1.32-.75-1.8-.2-.48-.4-.42-.55-.42h-.47c-.16 0-.42.06-.64.3-.22.24-.84.82-.84 2s.86 2.32.98 2.48c.12.16 1.7 2.6 4.12 3.64.58.25 1.03.4 1.38.51.58.18 1.1.16 1.52.1.46-.07 1.44-.59 1.64-1.16.2-.57.2-1.06.14-1.16-.06-.1-.22-.16-.46-.28z"/></svg>';
    var waMsg = L('Hi! I would like to order:', 'السلام عليكم 🌸 حابّة أطلب:') + '\n' + typeInfo().ar + (itemDesc ? ' — ' + itemDesc : '') + '\n' + priceStr + '\n' + ((window.location && window.location.href) || '');
    var waHref = 'https://wa.me/97433466002?text=' + encodeURIComponent(waMsg);
    return '<div class="mt-5 flex flex-col gap-2.5">' +
      '<button type="button" data-pdp-buy' + (disabled ? ' disabled' : '') + ' class="w-full rounded-2xl bg-primary py-4 text-base font-semibold text-primary-foreground transition hover:bg-primary/90 disabled:opacity-50">' + esc(buyLabel) + ' · ' + esc(priceStr) + '</button>' +
      '<button type="button" data-pdp-add' + (disabled ? ' disabled' : '') + ' class="w-full rounded-2xl border-2 border-primary bg-card py-4 text-base font-semibold text-primary transition hover:bg-primary/10 disabled:opacity-50">' + esc(addLabel) + ' · ' + esc(priceStr) + '</button>' +
      '<a href="' + waHref + '" target="_blank" rel="noopener" class="flex w-full items-center justify-center gap-2 rounded-2xl py-4 text-base font-semibold text-white transition hover:opacity-90" style="background:#25D366">' + waIcon + '<span>' + esc(waLabel) + '</span></a>' +
      '</div>';
  }

  function buildLine() {
    var tier = tierByQty(state.qty);
    var ti = typeInfo();
    var slots = [];
    for (var i = 0; i < state.slots.length; i++) {
      var s = state.slots[i];
      var col = colorByName(s.color), sc = SHOW_SCENT ? scentById(s.scent) : null;
      var variant = findVariant(s.color, (HAS_SCENT && sc) ? (isAr ? sc.ar : sc.en) : null);
      if (!variant) { err(L("That combination isn't available", 'هذه التركيبة غير متوفرة حالياً')); return null; }
      slots.push({ typeEn: ti.en, typeAr: ti.ar, colorEn: colorEnOf(col.name), colorAr: colorAr(col.name), scentEn: sc ? sc.en : '', scentAr: sc ? sc.ar : '', image: col.image || activeGalleryUrl || '', variantId: variant.id, price: variant.price });
    }
    // Single bills the product's OWN variant at its real price P; Duo/Trio bill the shared tier variant.
    var billVariantId = tier.variantId, billPrice = tier.price;
    if (state.qty === 1 && slots[0]) { billVariantId = slots[0].variantId; billPrice = slots[0].price != null ? slots[0].price : tier.price; }
    return { tierVariantId: billVariantId, bundleLabelEn: tier.labelEn, bundleLabelAr: tier.labelAr, totalPrice: billPrice, nameEn: ti.en, nameAr: ti.ar, image: slots[0] ? slots[0].image : (activeGalleryUrl || ''), slots: slots };
  }

  function flashScentHint(btn) {
    var slotEl = btn.closest('[data-slot]');
    var hint = slotEl && slotEl.querySelector('[data-scent-hint]');
    if (!hint) return;
    hint.classList.remove('hidden');
    clearTimeout(hint.__t);
    hint.__t = setTimeout(function () { hint.classList.add('hidden'); }, 2800);
  }

  // events
  controls.addEventListener('click', function (e) {
    var t = e.target.closest('[data-tier]');
    if (t) { state.qty = parseInt(t.getAttribute('data-tier'), 10); syncSlots(); render(); return; }
    var sl = e.target.closest('[data-slot]');
    if (sl && !e.target.closest('[data-pick-color]') && !e.target.closest('[data-pick-scent]')) { state.active = parseInt(sl.getAttribute('data-slot'), 10); render(); return; }
    var pc = e.target.closest('[data-pick-color]');
    if (pc && !pc.disabled) {
      var idx = parseInt(pc.closest('[data-slot]').getAttribute('data-slot'), 10);
      state.active = idx;
      var newColor = pc.getAttribute('data-pick-color');
      state.slots[idx].color = newColor;
      // Drop a now-incompatible scent so the slot doesn't read "complete" yet fail on add.
      if (HAS_SCENT) {
        var curScent = scentById(state.slots[idx].scent);
        var v = curScent ? findVariant(newColor, isAr ? curScent.ar : curScent.en) : null;
        if (!v || !v.available) state.slots[idx].scent = '';
      }
      render(); return;
    }
    var ps = e.target.closest('[data-pick-scent]');
    if (ps && !ps.disabled) {
      var i2 = parseInt(ps.closest('[data-slot]').getAttribute('data-slot'), 10);
      if (!state.slots[i2].color) { flashScentHint(ps); return; } // no colour yet -> gentle nudge, don't select
      state.active = i2; state.slots[i2].scent = ps.getAttribute('data-pick-scent'); render(); return;
    }
  });

  wireCtas(function () {
    if (!isComplete()) { err(L('Complete every item', 'أكملي اختيار كل قطعة')); return null; }
    var line = buildLine();
    return line ? { simple: false, line: line } : null;
  });

  function wireCtas(get) {
    // Un-stick a frozen express button if the page is restored from the back-forward cache
    // after the shopper tapped Buy-it-now and pressed Back. Registered here so it covers BOTH
    // charm mode and the simple add-on mode (which returns early before the charm-mode setup).
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      var b = controls.querySelector('[data-pdp-buy]');
      if (b && b.disabled) { b.disabled = false; var lbl = b.getAttribute('data-orig-label'); if (lbl != null) b.textContent = lbl; }
    });
    controls.addEventListener('click', function (e) {
      var add = e.target.closest('[data-pdp-add]');
      var buy = e.target.closest('[data-pdp-buy]');
      if (!add && !buy) return;
      var r = get(); if (!r) return;
      if (buy) {
        var btn = buy, orig = btn.textContent;
        btn.setAttribute('data-orig-label', orig);
        btn.disabled = true; btn.textContent = L('Loading...', 'إعداد...');
        var addP = r.simple ? window.CharmiesCart.addSimple(r.line, { express: true }) : window.CharmiesCart.addBundle(r.line, { express: true });
        addP.then(function (cart) { return window.CharmiesCart.checkout(cart); }) // pass settled cart -> skip second settle (faster)
          .catch(function () { btn.disabled = false; btn.textContent = orig; err(L('Checkout failed', 'تعذر إنشاء الطلب')); });
      } else {
        var p = r.simple ? window.CharmiesCart.addSimple(r.line) : window.CharmiesCart.addBundle(r.line);
        // Add-to-Cart (non-buy): surface failures instead of failing silently.
        p.catch(function (ex) { err((ex && ex.data && ex.data.description) || L('Sorry — could not add to cart. Please try again.', 'عذراً، تعذّرت الإضافة إلى السلة. حاولي مرة أخرى.')); });
      }
    });
  }

  render();
})();
